import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Tappable } from '@vectord/components';

import {
  MENTEE_MODULE_STATUSES,
  setSelectedMenteeModule,
  setUpdateMenteeModuleModalState,
} from 'features/moduleManagement';

function MoveToCoreCurriculumButton({ menteeModule }) {
  const dispatch = useDispatch();

  const handleOnClick = useCallback(() => {
    batch(() => {
      dispatch(setUpdateMenteeModuleModalState(true));
      dispatch(
        setSelectedMenteeModule({
          ...menteeModule,
          updatedStatus: MENTEE_MODULE_STATUSES.completed,
        })
      );
    });
  }, [dispatch, menteeModule]);

  return (
    <Tappable
      className="primary"
      onClick={handleOnClick}
    >
      Move To Core Curriculum Page
    </Tappable>
  );
}

export default MoveToCoreCurriculumButton;
